import { IconPropsType } from '..';

export const PlusIcon = ({ colored, ...props }: IconPropsType) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.2001 6.21323H7.78826V2.80003H6.21326V6.21323H2.80006V7.78823H6.21326V11.2H7.78826V7.78823H11.2001V6.21323Z"
      fill="currentColor"
    />
  </svg>
);
